//
// js-clipboard.js - clipboard copier and action callbacker
//
// data-js-clipboard                              kick-off
// data-js-clipboard-target-selector              ('this'|null|selector - e.g "#my-thinger", '.my-thinger') - note: if null, will look for a descendant with "data-js-clipboard-target-selector", followed by a whole document lookup

// data-js-clipboard-success-class                class to add to target when copy successful (required)
// data-js-clipboard-remove-success-class-after   remove the added classes after (numerical, optional)
// data-js-clipboard-class-delay                  delay adding class on successful copy (numerical, optional)
// data-js-clipboard-prevent                      prevent the default on-click event (optional)
// data-js-clipboard-text                         the text to copy
//

import clipboard_js from 'clipboard';


function cb_success(ev, el) {
  const target_selector            = el.getAttribute('data-js-clipboard-target-selector');
  const success_class              = el.getAttribute('data-js-clipboard-success-class');
  const class_addition_delay       = el.getAttribute('data-js-clipboard-success-class-delay');
  const remove_success_class_after = el.getAttribute('data-js-clipboard-remove-success-class-after');

  let target_el;
  if (target_selector !== null && (target_selector === 'this' || target_selector === 'true' || target_selector === '')) {
    target_el = el;
  }
  else {
    if (el.querySelectorAll('[data-js-clipboard-target-selector]')) {
      [ target_el ] = el.querySelectorAll('[data-js-clipboard-target-selector]');
    }
    else {
      target_el = document.querySelector(target_selector);
    }
  }

  if (!target_el) {
    console.log('js-clipboard: no valid target supplied.')
    return;
  }

  if (success_class) {
    const delay = class_addition_delay && preg_match(/^\d+$/, class_addition_delay) ? parseInt(class_addition_delay) : 0;
    setTimeout(_ => {
      const classes = success_class.split(/\s+/);
      classes.forEach(c => target_el.classList.add(c));

      if (remove_success_class_after) {
        setTimeout(() => {
          classes.forEach(c => target_el.classList.remove(c));
        }, remove_success_class_after);
      }
    }, delay);

    setTimeout(() => target_el.classList.remove(success_class), 4000);
  }
}


function clipboard(el) {
  if (el.hasAttribute('data-js-clipboard-prevent')) {
    el.addEventListener('click', ev => ev.preventDefault());
  }

  const text_to_copy = el.getAttribute('data-js-clipboard-text');
  if (!text_to_copy) {
    console.log('js-clipboard: requires data-js-clipboard-text to be set.');
    return;
  }
  el.setAttribute('data-clipboard-text', text_to_copy); // convert our naming convention to that needed by plugin

  const clip = new clipboard_js(el);
  clip.on('success', ev => cb_success(ev, el));
}


function init() {
  const items = Array.from(document.querySelectorAll('[data-js-clipboard]'));
  items.forEach(clipboard);
}
init();

